import Link from 'next/link';
import type {ComponentPropsWithoutRef} from 'react';
import {type ForwardedRef, forwardRef} from 'react';
import {useIsAppWebView} from '../hooks/useIsAppWebView';

type NextLink = ComponentPropsWithoutRef<typeof Link>;
type AnchorLink = ComponentPropsWithoutRef<'a'>;

/**
 * Nextjsと普通のaタグで競合する型はhrefのみ \
 * `scroll`など、Nextjs固有の型も存在するが、\
 * それが仮にaタグに渡されたとしても無視されるだけ
 */
type CommonLinkProps = Omit<NextLink, 'href'> &
  Omit<AnchorLink, 'href'> & {
    href: string;
  };

export const CommonLink = forwardRef<HTMLAnchorElement, CommonLinkProps>(
  ({href, children, ...props}, ref: ForwardedRef<HTMLAnchorElement>) => {
    const isWebView = useIsAppWebView();
    if (isWebView) {
      return (
        <a href={href} ref={ref} {...props}>
          {children}
        </a>
      );
    }

    return (
      <Link href={href} ref={ref} {...props}>
        {children}
      </Link>
    );
  },
);
